// MUST stay the first import: this strips the magic-link token from the URL
// fragment, and `app.config` calls Sentry.init at module-evaluation time with
// session replay at 100%. ES modules evaluate in import order, so moving this
// below `app.config` would ship the bearer token to Sentry (ADR 0035).
import './app/public-order/utils/invitation-token-capture';
import { bootstrapApplication } from '@angular/platform-browser';
import { initializeApp } from 'firebase/app';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

initializeApp(environment.firebase);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
